<div class="location-list">
    @if (isFetching) {
        <ul class="location-list__grid">
            @for (item of fetchingItems; track idx; let idx = $index) {
                <li class="location-list__item">
                    <div class="location-list__image">
                        <figure #imageRef>
                            <ngx-skeleton-loader
                                    [theme]="{height: imageRef.clientHeight + 'px', margin: 0}"
                            ></ngx-skeleton-loader>
                        </figure>
                    </div>

                    <div class="location-list__content">
                        <div class="location-list__name location-list__name--fetching" #nameRef>
                            <ngx-skeleton-loader
                                    [theme]="{height: nameRef.clientHeight + 'px', margin: 0}"
                            ></ngx-skeleton-loader>
                        </div>

                        <div class="location-list__links">
                            <div class="location-list__link location-list__link--fetching location-list__link--linked"
                                 #linkRef>
                                <ngx-skeleton-loader
                                        [theme]="{height: linkRef.clientHeight + 'px', margin: 0}"
                                ></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <ul class="location-list__grid">
            @if (activeItems.length) {
                @for (item of activeItems; track idx; let idx = $index) {
                    <li class="location-list__item">
                        <div class="location-list__image">
                            <figure>
                                <img [src]="item.imageUrl" alt="region-image">
                            </figure>
                        </div>

                        <div class="location-list__content">
                            <h5 class="location-list__name">
                                {{ item.name }}
                            </h5>

                            <div class="location-list__links">
                                <a href="" class="location-list__link location-list__link--linked"
                                   [routerLink]="item.link">
                                    <img class="map" src="assets/svg/ic-map-location.svg" alt="map-location-icon">
                                    <span>{{ 'LOCATION_LIST.ABOUT' | translate }} ></span>
                                </a>

                                @if (dataType === eInfoType.REGION) {
                                    <a href="" (click)="preventDefault($event)" class="location-list__link"
                                       [matMenuTriggerFor]="menu"
                                       (menuOpened)="openSearchMenu(idx)"
                                       (menuClosed)="closeSearchMenu(idx, searchLinkComponent);"
                                    >
                                        <img class="mountain" src="assets/svg/ic-mountain-city.svg"
                                             alt="map-location-icon">
                                        <span class="label-with-icon">{{ 'LOCATION_LIST.CITIES' | translate }}
                                            <mat-icon
                                                    class="angle-icon"
                                                    [class.angle-icon--opened]="menuOpened[idx]"
                                                    [svgIcon]="eSvgIcons.ANGLE_DOWN"
                                            ></mat-icon>
                                        </span>
                                    </a>
                                    <mat-menu [class]="'search-link'" #menu="matMenu">
                                        <app-search-link
                                                [isLoading]="isLoadingCities(cityCache[data[idx].region_id]?.dataSearch)"
                                                [placeholder]="'LOCATION_LIST.SEARCH_CITY' | translate"
                                                [loadingPlaceholder]="'LOCATION_LIST.CITIES_LOADING' | translate"
                                                [data]="cityCache[data[idx].region_id]?.data || []"
                                                [dataSearch]="cityCache[data[idx].region_id]?.dataSearch || []"
                                                [filterByKey]="'name'"
                                                #searchLinkComponent
                                        ></app-search-link>
                                    </mat-menu>
                                } @else if (dataType === eInfoType.CITY) {
                                    @if (isThingsTodo(item) && getThingsTodoLink(item?.name)) {
                                        <a href="" class="location-list__link location-list__link--linked"
                                           [routerLink]="getThingsTodoLink(item.name)">
                                            <img class="map-pin" src="assets/svg/ic-map-pin.svg" alt="map-pin-icon">
                                            <span>{{ 'LOCATION_LIST.THINGS_TO_DO' | translate }} ></span>
                                        </a>
                                    }
                                }
                            </div>
                        </div>
                    </li>
                }
            } @else {
                <li class="location-list__item location-list__item--empty">
                    @if (dataType === eInfoType.REGION) {
                        {{ 'LOCATION_LIST.REGION_NOT_FOUND' | translate }}
                    } @else if (dataType === eInfoType.CITY) {
                        {{ 'LOCATION_LIST.DESTINATION_NOT_FOUND' | translate }}
                    }
                </li>
            }
        </ul>

        @if (showMorePlacesCount > 0) {
            <div class="location-list__more">
                <a class="orangeLink" (click)="showMore()">
                    {{ 'LOCATION_LIST.SHOW_MORE' | translate }}
                </a>
            </div>
        }
    }
</div>
